import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { localStorageGetItem } from '@syntra/ui/utils/storage-available';
import helpCenterTranslationsEn from '@src/domains/help-center/translations/en.json';
import helpCenterTranslationsEl from '@src/domains/help-center/translations/el.json';
import companyTranslationsEn from '@src/domains/business/company/translations/en.json';
import companyTranslationsEl from '@src/domains/business/company/translations/el.json';
import userAccountTranslationsEn from '@src/domains/user-account/translations/en.json';
import userAccountTranslationsEl from '@src/domains/user-account/translations/el.json';
import reportsTranslationsEn from '@src/domains/business/reports/translations/en.json';
import reportsTranslationsEl from '@src/domains/business/reports/translations/el.json';
import supportTicketTranslationsEn from '@src/domains/support-ticket/translations/en.json';
import supportTicketTranslationsEl from '@src/domains/support-ticket/translations/el.json';
import userAfterLoginTranslationsEn from '@src/domains/user-after-login/translations/en.json';
import userAfterLoginTranslationsEl from '@src/domains/user-after-login/translations/el.json';
import companyDashboardTranslationsEn from '@src/domains/company-dashboard/translations/en.json';
import companyDashboardTranslationsEl from '@src/domains/company-dashboard/translations/el.json';
import customFieldsTranslationsEn from '@src/domains/business/custom-fields/translations/en.json';
import customFieldsTranslationsEl from '@src/domains/business/custom-fields/translations/el.json';
import companyPartnerTranslationsEn from '@src/domains/business/company-partner/translations/en.json';
import companyPartnerTranslationsEl from '@src/domains/business/company-partner/translations/el.json';
import companyProjectTranslationsEn from '@src/domains/business/company-project/translations/en.json';
import companyProjectTranslationsEl from '@src/domains/business/company-project/translations/el.json';
import userManagementTranslationsEn from '@src/domains/business/user-management/translations/en.json';
import userManagementTranslationsEl from '@src/domains/business/user-management/translations/el.json';
import roleManagementTranslationsEn from '@src/domains/business/role-management/translations/en.json';
import roleManagementTranslationsEl from '@src/domains/business/role-management/translations/el.json';
import companyProjectActionTranslationsEn from '@src/domains/business/company-project-action/translations/en.json';
import companyProjectActionTranslationsEl from '@src/domains/business/company-project-action/translations/el.json';
import companyProjectCategoryTranslationsEn from '@src/domains/business/company-project-category/translations/en.json';
import companyProjectCategoryTranslationsEl from '@src/domains/business/company-project-category/translations/el.json';

import navEn from 'src/locales/translations/nav/en.json';
import navEl from 'src/locales/translations/nav/el.json';
import layoutsEn from 'src/layouts/translations/en.json';
import layoutsEl from 'src/layouts/translations/el.json';
import commonEn from 'src/locales/translations/common/en.json';
import commonEl from 'src/locales/translations/common/el.json';

import dataTransferEn from 'src/components/data-transfer/translations/en.json';
import dataTransferEl from 'src/components/data-transfer/translations/el.json';

import { defaultLang } from './config-lang';
import translationEn from './langs/en.json';
import translationFr from './langs/fr.json';

// ----------------------------------------------------------------------

const lng = localStorageGetItem('i18nextLng', defaultLang.value);
// const loadResources = async (locale: string) => axiosInstance.get(endpoints.translations, { params: { lang: locale } })
//   .then((response) => response.data)
//   .catch((error) => { console.log(error); })
// // ----------------------------------------------------------------------
// const backendOptions = {
//   loadPath: '{{locale}}|{{ns}}',
//   request: (options: any, url: any, payload: any, callback: any) => {
//     try {
//       const [locale] = url.split('|');
//       console.log('locale', locale);
//       loadResources(locale).then((response) => {
//         callback(null, {
//           data: response,
//           status: 200,
//         });
//       });
//     } catch (e) {
//       console.error(e);
//       callback(null, {
//         status: 500,
//       });
//     }
//   },
// };
// ----------------------------------------------------------------------

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translations: translationEn,
        nav: navEn,
        common: commonEn,
        layouts: layoutsEn,
        companyProjectCategory: companyProjectCategoryTranslationsEn,
        companyProject: companyProjectTranslationsEn,
        companyPartner: companyPartnerTranslationsEn,
        companyProjectAction: companyProjectActionTranslationsEn,
        supportTicket: supportTicketTranslationsEn,
        company: companyTranslationsEn,
        companyDashboard: companyDashboardTranslationsEn,
        userAccount: userAccountTranslationsEn,
        userAfterLogin: userAfterLoginTranslationsEn,
        userManagement: userManagementTranslationsEn,
        roleManagement: roleManagementTranslationsEn,
        customFields: customFieldsTranslationsEn,
        reports: reportsTranslationsEn,
        dataTransfer: dataTransferEn,
        helpCenter: helpCenterTranslationsEn,
      },
      el: {
        translations: translationFr,
        nav: navEl,
        common: commonEl,
        layouts: layoutsEl,
        companyProjectCategory: companyProjectCategoryTranslationsEl,
        companyProject: companyProjectTranslationsEl,
        companyPartner: companyPartnerTranslationsEl,
        companyProjectAction: companyProjectActionTranslationsEl,
        company: companyTranslationsEl,
        companyDashboard: companyDashboardTranslationsEl,
        supportTicket: supportTicketTranslationsEl,
        userAccount: userAccountTranslationsEl,
        userAfterLogin: userAfterLoginTranslationsEl,
        userManagement: userManagementTranslationsEl,
        roleManagement: roleManagementTranslationsEl,
        customFields: customFieldsTranslationsEl,
        reports: reportsTranslationsEl,
        dataTransfer: dataTransferEl,
        helpCenter: helpCenterTranslationsEl,
      },
    },
    lng,
    // Fallback to English if a key is missing in the active language
    fallbackLng: 'en',
    debug: false,
    ns: [
      'translations',
      'nav',
      'common',
      'layouts',
      'companyProjectCategory',
      'companyProject',
      'companyPartner',
      'companyProjectAction',
      'company',
      'supportTicket',
      'userAccount',
      'userAfterLogin',
      'userManagement',
      'roleManagement',
      'customFields',
      'reports',
      'dataTransfer',
      'helpCenter',
    ],
    defaultNS: 'translations',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
